import { Component } from '@theme/component';

class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#toggleVisibility();
    document.addEventListener('variant:selected', () => {
      this.#toggleVisibility();
    });
  }

  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;
    const template = characterCount.getAttribute('data-template');
    if (!template) return;
    const updatedText = template
      .replace('[current]', currentLength.toString())
      .replace('[max]', maxLength.toString());
    characterCount.textContent = updatedText;
  }

  #toggleVisibility() {
    const checkedInput = document.querySelector(
      'variant-picker fieldset input:checked'
    );
    const label = checkedInput?.closest('label')?.textContent?.trim().toLowerCase() || '';
    const isSansGravure = label.includes('sans gravure');
    this.style.display = isSansGravure ? 'none' : '';

    // Vider le champ si caché
    if (isSansGravure) {
      const input = this.querySelector('input, textarea');
      if (input) input.value = '';
    }
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);